module.exports = __webpack_public_path__ + "static/media/switch-to-sid.ee86488e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/switch-to-sid.svg
// module id = 478
// module chunks = 21